import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from 'lib/@mui';

import EzloActions from '../../actions/EzloActions';

import { MeshBotAction } from 'actions';
import { Tooltip } from 'components';
import { useTranslate } from 'features/languages';
import { ADVANCED_SCENES } from 'constants/ControllerFeatures';
import { EZLOGIC_TITLE_STATUS_MESHBOT_FROM_ADVANCED_SCENE_1_74 } from 'constants/language_tokens';
import { isCloudMeshBotType, shouldDisableSystemTcdsActions } from 'containers/Ezlo/EzloMeshbot/utils';
import { MESHBOT_TYPES } from '../../containers/Ezlo/EzloMeshbots/constants';

import './style.scss';

const MeshbotSwitch = ({ renderedCellValue: params }) => {
    const [switcher, setSwitcher] = useState(true);
    const dispatch = useDispatch();
    const { t } = useTranslate();
    const ezloData = useSelector((state) => state.ezlo?.data?.[params?.serial]);
    const isTcdsDisabled = shouldDisableSystemTcdsActions(params, ezloData, ADVANCED_SCENES.VERSION_1_74);
    const isDisabledSwitchBtn = params && params.isDisabled;
    const isEzlopiType = params.type === MESHBOT_TYPES.EZLOPI;

    useEffect(() => {
        setSwitcher(params.enabled);
    }, [params]);

    const handleChange = (event) => {
        const { serial, id, type } = params || {};
        const isMeshBotActive = event.target.checked;
        if (serial) {
            dispatch(EzloActions.updateLocalMeshBotStatus(serial, id, isMeshBotActive));
        } else if (isCloudMeshBotType(type)) {
            dispatch(MeshBotAction.updateCloudMeshbotStatus(params, isMeshBotActive));
        }
        setSwitcher(isMeshBotActive);
    };

    return (
        <div className="switch-wrapper">
            <Tooltip
                title={
                    isTcdsDisabled && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: t(EZLOGIC_TITLE_STATUS_MESHBOT_FROM_ADVANCED_SCENE_1_74),
                            }}
                        />
                    )
                }
                position="top"
            >
                <div>
                    <Switch
                        size="medium"
                        disabled={isDisabledSwitchBtn || isEzlopiType || isTcdsDisabled}
                        checked={switcher}
                        onChange={handleChange}
                        color="primary"
                        name="switcher"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                </div>
            </Tooltip>
        </div>
    );
};

export default MeshbotSwitch;
